exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../../../css-loader/dist/cjs.js??ref--7-oneOf-2-1!../../../../../postcss-loader/src/index.js??postcss!./checklist-theme.css"), "");

// Module
exports.push([module.id, ".c-checklist {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1;\n  font-size: 1rem;\n  line-height: 1.15;\n}\n\n.c-checklist__items {\n  min-height: 0;\n  overflow: auto;\n}\n\n.c-checklist__item + .c-checklist__item {\n  margin-top: var(--tws-checklist-spacing);\n}\n\n.c-checklist__check-all {\n  padding-top: var(--tws-checklist-spacing);\n  border-top: 1px solid hsl(var(--color-gray-15));\n}\n", ""]);

